import React, { Fragment } from 'react';

const HelpItem8 = () => {
    return (
        <Fragment>
            <p className='p'>
                When you select the photo wall you will see interesting photos submitted by the restaurants.
            </p>
            <p className='p'>
                Clicking the photo will reveal a caption and a link to the restaurant detail page which includes menus, associates and entertainment items.
            </p>
        </Fragment>
    );
};

export default HelpItem8;